import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export default function Connexion() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      navigate(user.role === "admin" ? "/admin" : user.role === "qualificateur" ? "/qualif" : "/pro");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] px-6 py-20">
      <div className="mx-auto max-w-md">
        <Link to="/" className="inline-block">
          <Logo className="h-20" />
        </Link>
        <h1 className="mt-12 text-4xl font-extrabold tracking-tighter">Espace partenaires</h1>
        <p className="mt-3 text-neutral-500">Auto-écoles et administration.</p>
        <form onSubmit={submit} className="mt-10 space-y-4">
          <input
            data-testid="login-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="w-full rounded-lg border border-neutral-300 bg-white px-4 py-3 outline-none focus:border-brand transition-colors"
          />
          <input
            data-testid="login-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Mot de passe"
            className="w-full rounded-lg border border-neutral-300 bg-white px-4 py-3 outline-none focus:border-brand transition-colors"
          />
          <div className="text-right">
            <Link to="/mot-de-passe-oublie" data-testid="forgot-password-link" className="text-sm font-semibold text-brand underline underline-offset-4">
              Mot de passe oublié ?
            </Link>
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-btn"
            className="w-full rounded-full bg-brand px-6 py-4 font-bold text-white transition-colors hover:bg-brand-hover disabled:opacity-60"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
        <p className="mt-8 text-sm text-neutral-500">
          Pas encore partenaire ?{" "}
          <Link to="/inscription-auto-ecole" data-testid="goto-register-link" className="font-semibold text-brand underline underline-offset-4">
            Créer un compte auto-école
          </Link>
        </p>
      </div>
    </div>
  );
}
